// extracted by mini-css-extract-plugin
export default {"news":"NewsContent_news__2s6w0"};